// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Submit__pc_only___1VroX","sp_only":"Submit__sp_only___2Pe2r","submit":"Submit__submit___1_2bn","right":"Submit__right___17mHS","left":"Submit__left___sh_eY"};